export default __webpack_public_path__ + "static/media/5.d6ae5eb5.jpg";